import { toast } from 'react-toastify';
import { LOAD_STATES, LOAD_OPTIONS, LOAD_BANKS } from '../reducers/utils';
import AxiosClient from '../utils/AxiosClient';

export const schedule = async ({ duration, tenor_period = "days", interest_rate, loan_amount }) => {
  const client = await AxiosClient();
  return (await client.get(`util/schedule?duration=${duration}&tenor_period=${tenor_period}&interest_rate=${interest_rate}&loan_amount=${loan_amount}`))?.data;
};

export const getAllStates = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get('/meta/codes?code_description=state');
    dispatch({ type: LOAD_STATES, data: response.data.data || [] });
  } catch (error) {
    toast.error(error.response?.data?.message || error.response?.statusText
      || error.message
      || 'Seems like something went wrong with your request. Please try again.');
  }
};

export const getOptions = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get('/settings/profile/options');
    dispatch({ type: LOAD_OPTIONS, data: response.data.data || [] });
  } catch (error) {
    toast.error(error.response?.data?.message || error.response?.statusText
      || error.message
      || 'Seems like something went wrong with your request. Please try again.');
  }
};

export const getBanks = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get('/util/codes/fetch/bank');
    dispatch({ type: LOAD_BANKS, data: response.data.data || [] });
  } catch (error) {
    toast.error(error.response?.data?.message || error.response?.statusText
      || error.message
      || 'Seems like something went wrong with your request. Please try again.');
  }
};

export const getLoanStatus = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get('business/loan/status');
    console.log(response)
    dispatch({ type: LOAD_OPTIONS, data: response.data.data || [] });
  } catch (error) {
    toast.error(error.response?.data?.message || error.response?.statusText
      || error.message
      || 'Seems like something went wrong with your request. Please try again.');
  }
};
